function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//

import * as React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet, color } from "../../styles/theme";

/**
 * A simple divider that can accept children
 * Sample Usage:
 * <Divider />
 */

var styles = StyleSheet.create({
  Divider: {
    margin: 0,
    height: 1,
    border: 'none',
    backgroundColor: color.divider
  },
  bgThemeDark: {
    backgroundColor: color.dividerThemeDark
  },
  flex1: {
    flex: 1
  },
  dividerWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
});
var Divider = function Divider(_ref) {
  var _ref$htmlAttributes = _ref.htmlAttributes,
    htmlAttributes = _ref$htmlAttributes === void 0 ? {} : _ref$htmlAttributes,
    _ref$isThemeDark = _ref.isThemeDark,
    isThemeDark = _ref$isThemeDark === void 0 ? false : _ref$isThemeDark,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$inset = _ref.inset,
    inset = _ref$inset === void 0 ? 0 : _ref$inset,
    _ref$isDoubleInset = _ref.isDoubleInset,
    isDoubleInset = _ref$isDoubleInset === void 0 ? false : _ref$isDoubleInset,
    children = _ref.children;
  var singleDivider = /*#__PURE__*/React.createElement("hr", _extends({}, htmlAttributes, css(styles.Divider, isThemeDark && styles.bgThemeDark), {
    style: _objectSpread({
      marginLeft: inset,
      marginRight: isDoubleInset && inset
    }, style)
  }));
  if (!children) {
    return singleDivider;
  }
  singleDivider = /*#__PURE__*/React.createElement("hr", _extends({}, htmlAttributes, css(styles.Divider, isThemeDark && styles.bgThemeDark, styles.flex1), {
    style: _objectSpread({
      marginLeft: inset
    }, style)
  }));
  return /*#__PURE__*/React.createElement("div", css('Divider', styles.dividerWrapper), singleDivider, children, singleDivider);
};

// Explicity declare the default props for documentation purpose
Divider.defaultProps = {
  htmlAttributes: {},
  style: {},
  inset: 0,
  isThemeDark: false,
  isDoubleInset: false
};
Divider.propTypes = {
  // Additional control for the root element, can add data-courselenium, ariaLabel...
  htmlAttributes: PropTypes.object,
  // Whether divder has parent element with dark bg
  isThemeDark: PropTypes.bool,
  // Whether divider will be indented
  inset: PropTypes.number,
  // Whether divider is indented from both sides
  isDoubleInset: PropTypes.bool,
  // Overwrite the inline-styles of the root element
  style: PropTypes.object,
  // If childen exists, we'll render a box which has left and right divider and children in the middle
  children: PropTypes.node
};
export default Divider;